import * as Types from '../../../generated/webapp_gql';

import { ProgramPreviewFragment } from '../../newPrograms/documents/getProgram.generated';
import { gql } from 'graphql.macro';
import { ProgramPreviewFragmentDoc } from '../../newPrograms/documents/getProgram.generated';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHoc from '@apollo/react-hoc';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions =  {}
export type ContentLink_AssessmentLinkNode_Fragment = (
  { __typename?: 'AssessmentLinkNode' }
  & Pick<Types.AssessmentLinkNode, 'id'>
);

export type ContentLink_CircleSeriesLinkNode_Fragment = (
  { __typename?: 'CircleSeriesLinkNode' }
  & Pick<Types.CircleSeriesLinkNode, 'id'>
  & { circleSeries?: Types.Maybe<(
    { __typename?: 'CircleSeriesNode' }
    & Pick<Types.CircleSeriesNode, 'id' | 'uuid' | 'url' | 'description' | 'shortDescription' | 'name' | 'illustration' | 'slug'>
    & { topics: (
      { __typename?: 'CircleTopicConnection' }
      & { edges: Array<Types.Maybe<(
        { __typename?: 'CircleTopicEdge' }
        & { node: (
          { __typename?: 'CircleTopicNode' }
          & Pick<Types.CircleTopicNode, 'id' | 'duration'>
        ) }
      )>> }
    ) }
  )> }
);

export type ContentLink_CircleSessionLinkNode_Fragment = (
  { __typename?: 'CircleSessionLinkNode' }
  & Pick<Types.CircleSessionLinkNode, 'id'>
);

export type ContentLink_CircleTopicLinkNode_Fragment = (
  { __typename?: 'CircleTopicLinkNode' }
  & Pick<Types.CircleTopicLinkNode, 'id'>
  & { circleTopic?: Types.Maybe<(
    { __typename?: 'CircleTopicNode' }
    & Pick<Types.CircleTopicNode, 'id' | 'name' | 'description' | 'slug' | 'duration' | 'format'>
    & { sessions: (
      { __typename?: 'CircleSessionConnection' }
      & { edges: Array<Types.Maybe<(
        { __typename?: 'CircleSessionEdge' }
        & { node: (
          { __typename?: 'CircleSessionNode' }
          & Pick<Types.CircleSessionNode, 'startTime'>
          & { facilitators: Array<Types.Maybe<(
            { __typename?: 'CircleFacilitatorNode' }
            & Pick<Types.CircleFacilitatorNode, 'photo'>
          )>> }
        ) }
      )>> }
    ) }
  )> }
);

export type ContentLink_CourseLinkNode_Fragment = (
  { __typename?: 'CourseLinkNode' }
  & Pick<Types.CourseLinkNode, 'id'>
  & { mediaType?: Types.Maybe<(
    { __typename?: 'MediaTypeNode' }
    & Pick<Types.MediaTypeNode, 'name' | 'icon'>
  )>, banner?: Types.Maybe<(
    { __typename?: 'ContentBannerNode' }
    & Pick<Types.ContentBannerNode, 'backgroundColor' | 'imageUrl'>
  )>, course: (
    { __typename?: 'CourseNode' }
    & Pick<Types.CourseNode, 'slug' | 'title' | 'subtitle' | 'thumbnailImageUrl' | 'duration' | 'isNew' | 'progressPercent'>
    & { progress: (
      { __typename?: 'CourseProgressNode' }
      & Pick<Types.CourseProgressNode, 'completedAt' | 'startedAt'>
    ), hero?: Types.Maybe<(
      { __typename?: 'CourseGraphicHeroNode' }
      & Pick<Types.CourseGraphicHeroNode, 'uuid' | 'id' | 'backgroundColor'>
      & { graphic: (
        { __typename?: 'ImageNode' }
        & Pick<Types.ImageNode, 'uuid' | 'id' | 'url'>
      ) }
    ) | (
      { __typename?: 'ImageNode' }
      & Pick<Types.ImageNode, 'uuid' | 'id' | 'url'>
    ) | (
      { __typename?: 'VideoContentNode' }
      & Pick<Types.VideoContentNode, 'uuid' | 'title' | 'sourceHorizontal' | 'sourceVertical' | 'id' | 'poster'>
    )> }
  ) }
);

export type ContentLink_ExternalLinkNode_Fragment = (
  { __typename?: 'ExternalLinkNode' }
  & Pick<Types.ExternalLinkNode, 'id' | 'url' | 'title' | 'subtitle' | 'image'>
);

export type ContentLink_HrEventLinkNode_Fragment = (
  { __typename?: 'HREventLinkNode' }
  & Pick<Types.HrEventLinkNode, 'id'>
  & { hrEvent: (
    { __typename?: 'HREventNode' }
    & Pick<Types.HrEventNode, 'title' | 'url' | 'image' | 'intendedAudience' | 'descriptiveDate'>
  ) }
);

export type ContentLink_HrResourceLinkNode_Fragment = (
  { __typename?: 'HRResourceLinkNode' }
  & Pick<Types.HrResourceLinkNode, 'id'>
  & { mediaType?: Types.Maybe<(
    { __typename?: 'MediaTypeNode' }
    & Pick<Types.MediaTypeNode, 'name' | 'icon'>
  )>, hrResource: (
    { __typename?: 'HRResourceNode' }
    & Pick<Types.HrResourceNode, 'title' | 'subtitle' | 'url' | 'intendedAudience' | 'image'>
  ) }
);

export type ContentLink_InternalLinkNode_Fragment = (
  { __typename?: 'InternalLinkNode' }
  & Pick<Types.InternalLinkNode, 'id' | 'path' | 'title' | 'titleTranslationKey' | 'subtitle' | 'image' | 'buttonText' | 'colorScheme' | 'providerInitials' | 'images' | 'labelText' | 'labelVariant' | 'recommended' | 'backgroundImage' | 'intendedAudience' | 'tileColor'>
  & { mediaType?: Types.Maybe<(
    { __typename?: 'MediaTypeNode' }
    & Pick<Types.MediaTypeNode, 'name' | 'icon'>
  )> }
);

export type ContentLink_MeditationLinkNode_Fragment = (
  { __typename?: 'MeditationLinkNode' }
  & Pick<Types.MeditationLinkNode, 'id'>
  & { mediaType?: Types.Maybe<(
    { __typename?: 'MediaTypeNode' }
    & Pick<Types.MediaTypeNode, 'name' | 'icon'>
  )>, banner?: Types.Maybe<(
    { __typename?: 'ContentBannerNode' }
    & Pick<Types.ContentBannerNode, 'backgroundColor' | 'imageUrl'>
  )>, meditation: (
    { __typename?: 'MeditationNode' }
    & Pick<Types.MeditationNode, 'uuid' | 'name' | 'slug' | 'description' | 'image' | 'duration' | 'isNew' | 'isCompleted' | 'isStarted' | 'progressPercent'>
    & { meditationProgress: Array<(
      { __typename?: 'MeditationProgressNode' }
      & Pick<Types.MeditationProgressNode, 'completedAt' | 'startedAt'>
    )> }
  ) }
);

export type ContentLink_ProgramLinkNode_Fragment = (
  { __typename?: 'ProgramLinkNode' }
  & Pick<Types.ProgramLinkNode, 'id'>
  & { mediaType?: Types.Maybe<(
    { __typename?: 'MediaTypeNode' }
    & Pick<Types.MediaTypeNode, 'name' | 'icon'>
  )>, banner?: Types.Maybe<(
    { __typename?: 'ContentBannerNode' }
    & Pick<Types.ContentBannerNode, 'backgroundColor' | 'imageUrl'>
  )>, program: (
    { __typename?: 'ProgramNode' }
    & Pick<Types.ProgramNode, 'uuid'>
    & ProgramPreviewFragment
  ) }
);

export type ContentLink_ScreenLinkNode_Fragment = (
  { __typename?: 'ScreenLinkNode' }
  & Pick<Types.ScreenLinkNode, 'id' | 'title' | 'subtitle' | 'image'>
  & { screen: { __typename: 'ContentTagListScreenNode' } | { __typename: 'ContentTagScreenNode' } | { __typename: 'CoursesScreenNode' } | (
    { __typename: 'DataDefinedScreenNode' }
    & Pick<Types.DataDefinedScreenNode, 'designatedApplication' | 'slug'>
  ) | { __typename: 'ExploreCareOptionsScreenNode' } | { __typename: 'ExploreScreenNode' } | { __typename: 'ForYouScreenNode' } | { __typename: 'HomeScreenNode' } | { __typename: 'ManageCareTeamScreenNode' } | { __typename: 'MeditationsScreenNode' } | { __typename: 'ProgramsScreenNode' } | { __typename: 'RecommendedScreenNode' } | { __typename: 'ResourcesScreenNode' } | { __typename: 'WellbeingReportScreenNode' } }
);

export type ContentLinkFragment = ContentLink_AssessmentLinkNode_Fragment | ContentLink_CircleSeriesLinkNode_Fragment | ContentLink_CircleSessionLinkNode_Fragment | ContentLink_CircleTopicLinkNode_Fragment | ContentLink_CourseLinkNode_Fragment | ContentLink_ExternalLinkNode_Fragment | ContentLink_HrEventLinkNode_Fragment | ContentLink_HrResourceLinkNode_Fragment | ContentLink_InternalLinkNode_Fragment | ContentLink_MeditationLinkNode_Fragment | ContentLink_ProgramLinkNode_Fragment | ContentLink_ScreenLinkNode_Fragment;

export type ScreenSectionFragment = (
  { __typename?: 'ScreenSectionNode' }
  & Pick<Types.ScreenSectionNode, 'id' | 'uuid' | 'index' | 'renderComponent' | 'minimumMobileVersion' | 'ctaLinkText' | 'title' | 'subtitle'>
  & { ctaLink?: Types.Maybe<(
    { __typename?: 'AssessmentLinkNode' }
    & Pick<Types.AssessmentLinkNode, 'id'>
    & ContentLink_AssessmentLinkNode_Fragment
  ) | (
    { __typename?: 'CircleSeriesLinkNode' }
    & Pick<Types.CircleSeriesLinkNode, 'id'>
    & ContentLink_CircleSeriesLinkNode_Fragment
  ) | (
    { __typename?: 'CircleSessionLinkNode' }
    & Pick<Types.CircleSessionLinkNode, 'id'>
    & ContentLink_CircleSessionLinkNode_Fragment
  ) | (
    { __typename?: 'CircleTopicLinkNode' }
    & Pick<Types.CircleTopicLinkNode, 'id'>
    & ContentLink_CircleTopicLinkNode_Fragment
  ) | (
    { __typename?: 'CourseLinkNode' }
    & Pick<Types.CourseLinkNode, 'id'>
    & ContentLink_CourseLinkNode_Fragment
  ) | (
    { __typename?: 'ExternalLinkNode' }
    & Pick<Types.ExternalLinkNode, 'id'>
    & ContentLink_ExternalLinkNode_Fragment
  ) | (
    { __typename?: 'HREventLinkNode' }
    & Pick<Types.HrEventLinkNode, 'id'>
    & ContentLink_HrEventLinkNode_Fragment
  ) | (
    { __typename?: 'HRResourceLinkNode' }
    & Pick<Types.HrResourceLinkNode, 'id'>
    & ContentLink_HrResourceLinkNode_Fragment
  ) | (
    { __typename?: 'InternalLinkNode' }
    & Pick<Types.InternalLinkNode, 'id'>
    & ContentLink_InternalLinkNode_Fragment
  ) | (
    { __typename?: 'MeditationLinkNode' }
    & Pick<Types.MeditationLinkNode, 'id'>
    & ContentLink_MeditationLinkNode_Fragment
  ) | (
    { __typename?: 'ProgramLinkNode' }
    & Pick<Types.ProgramLinkNode, 'id'>
    & ContentLink_ProgramLinkNode_Fragment
  ) | (
    { __typename?: 'ScreenLinkNode' }
    & Pick<Types.ScreenLinkNode, 'id'>
    & ContentLink_ScreenLinkNode_Fragment
  )>, contentCollectionLinks: Array<(
    { __typename?: 'AssessmentLinkNode' }
    & Pick<Types.AssessmentLinkNode, 'id'>
    & ContentLink_AssessmentLinkNode_Fragment
  ) | (
    { __typename?: 'CircleSeriesLinkNode' }
    & Pick<Types.CircleSeriesLinkNode, 'id'>
    & ContentLink_CircleSeriesLinkNode_Fragment
  ) | (
    { __typename?: 'CircleSessionLinkNode' }
    & Pick<Types.CircleSessionLinkNode, 'id'>
    & ContentLink_CircleSessionLinkNode_Fragment
  ) | (
    { __typename?: 'CircleTopicLinkNode' }
    & Pick<Types.CircleTopicLinkNode, 'id'>
    & ContentLink_CircleTopicLinkNode_Fragment
  ) | (
    { __typename?: 'CourseLinkNode' }
    & Pick<Types.CourseLinkNode, 'id'>
    & ContentLink_CourseLinkNode_Fragment
  ) | (
    { __typename?: 'ExternalLinkNode' }
    & Pick<Types.ExternalLinkNode, 'id'>
    & ContentLink_ExternalLinkNode_Fragment
  ) | (
    { __typename?: 'HREventLinkNode' }
    & Pick<Types.HrEventLinkNode, 'id'>
    & ContentLink_HrEventLinkNode_Fragment
  ) | (
    { __typename?: 'HRResourceLinkNode' }
    & Pick<Types.HrResourceLinkNode, 'id'>
    & ContentLink_HrResourceLinkNode_Fragment
  ) | (
    { __typename?: 'InternalLinkNode' }
    & Pick<Types.InternalLinkNode, 'id'>
    & ContentLink_InternalLinkNode_Fragment
  ) | (
    { __typename?: 'MeditationLinkNode' }
    & Pick<Types.MeditationLinkNode, 'id'>
    & ContentLink_MeditationLinkNode_Fragment
  ) | (
    { __typename?: 'ProgramLinkNode' }
    & Pick<Types.ProgramLinkNode, 'id'>
    & ContentLink_ProgramLinkNode_Fragment
  ) | (
    { __typename?: 'ScreenLinkNode' }
    & Pick<Types.ScreenLinkNode, 'id'>
    & ContentLink_ScreenLinkNode_Fragment
  )> }
);

export type ScheduledContentFragment = (
  { __typename?: 'ScheduledContentNode' }
  & Pick<Types.ScheduledContentNode, 'uuid' | 'contentType' | 'startTime' | 'bannerTitle' | 'bannerContent' | 'bannerCtaText' | 'bannerImage' | 'headerImage' | 'accentColor' | 'titleColor' | 'fullContent' | 'linkHeader' | 'isCompleted'>
  & { scheduledContentLinks: Array<(
    { __typename?: 'ScheduledContentLinkNode' }
    & Pick<Types.ScheduledContentLinkNode, 'uuid' | 'image' | 'index' | 'title' | 'subtitle' | 'linkType' | 'mobileValue' | 'webValue' | 'isCta'>
  )> }
);

export type BannerContentFragment = (
  { __typename?: 'ScheduledContentNode' }
  & Pick<Types.ScheduledContentNode, 'uuid' | 'contentType' | 'startTime' | 'bannerTitle' | 'bannerContent' | 'bannerCtaText' | 'bannerImage' | 'headerImage' | 'accentColor' | 'titleColor' | 'fullContent' | 'linkHeader' | 'isCompleted' | 'badgeTitle' | 'badgeVariant'>
  & { scheduledContentLinks: Array<(
    { __typename?: 'ScheduledContentLinkNode' }
    & Pick<Types.ScheduledContentLinkNode, 'uuid' | 'image' | 'index' | 'title' | 'subtitle' | 'linkType' | 'mobileValue' | 'webValue' | 'isCta'>
  )> }
);

export type ScreenFragment = (
  { __typename?: 'HomeScreenNode' }
  & Pick<Types.HomeScreenNode, 'id' | 'uuid' | 'name' | 'platform'>
  & { scheduledContent?: Types.Maybe<(
    { __typename?: 'ScheduledContentNode' }
    & Pick<Types.ScheduledContentNode, 'uuid'>
    & ScheduledContentFragment
  )>, bannerContent?: Types.Maybe<(
    { __typename?: 'ScheduledContentNode' }
    & BannerContentFragment
  )>, screenSections: Array<(
    { __typename?: 'ScreenSectionNode' }
    & Pick<Types.ScreenSectionNode, 'id'>
    & ScreenSectionFragment
  )>, featuredSection: (
    { __typename?: 'ScreenSectionNode' }
    & Pick<Types.ScreenSectionNode, 'id'>
    & ScreenSectionFragment
  ) }
);

export type GetHomeScreenQueryVariables = Types.Exact<{
  fetchScheduledContentActivity: Types.Scalars['Boolean'];
}>;


export type GetHomeScreenQuery = (
  { __typename?: 'Query' }
  & { homeScreen?: Types.Maybe<(
    { __typename?: 'HomeScreenNode' }
    & Pick<Types.HomeScreenNode, 'id'>
    & ScreenFragment
  )>, scheduledContentActivity?: Types.Maybe<(
    { __typename?: 'ScheduledContentActivitySummaryNode' }
    & Pick<Types.ScheduledContentActivitySummaryNode, 'dayStreakCount' | 'weekStreakCount'>
  )> }
);

export const ScheduledContentFragmentDoc = gql`
    fragment ScheduledContent on ScheduledContentNode {
  uuid
  contentType
  startTime
  bannerTitle
  bannerContent
  bannerCtaText
  bannerImage
  headerImage
  accentColor
  titleColor
  fullContent
  linkHeader
  isCompleted
  scheduledContentLinks {
    uuid
    image
    index
    title
    subtitle
    linkType
    mobileValue
    webValue
    isCta
  }
}
    `;
export const BannerContentFragmentDoc = gql`
    fragment BannerContent on ScheduledContentNode {
  uuid
  contentType
  startTime
  bannerTitle
  bannerContent
  bannerCtaText
  bannerImage
  headerImage
  accentColor
  titleColor
  fullContent
  linkHeader
  isCompleted
  badgeTitle
  badgeVariant
  scheduledContentLinks {
    uuid
    image
    index
    title
    subtitle
    linkType
    mobileValue
    webValue
    isCta
  }
}
    `;
export const ContentLinkFragmentDoc = gql`
    fragment ContentLink on ContentLinkNode {
  ... on Node {
    id
  }
  ... on ScreenLinkNode {
    title
    subtitle
    image
    screen {
      __typename
      ... on DataDefinedScreenNode {
        designatedApplication
        slug
      }
    }
  }
  ... on ProgramLinkNode {
    mediaType {
      name
      icon
    }
    banner {
      backgroundColor
      imageUrl
    }
    program {
      uuid
      ...ProgramPreview
    }
  }
  ... on MeditationLinkNode {
    mediaType {
      name
      icon
    }
    banner {
      backgroundColor
      imageUrl
    }
    meditation {
      uuid
      name
      slug
      description
      image
      duration
      isNew
      isCompleted @client
      isStarted @client
      progressPercent
      meditationProgress {
        completedAt
        startedAt
      }
    }
  }
  ... on ExternalLinkNode {
    url
    title
    subtitle
    image
  }
  ... on InternalLinkNode {
    path
    title
    titleTranslationKey
    subtitle
    image
    buttonText
    colorScheme
    providerInitials
    images
    labelText
    labelVariant
    recommended
    backgroundImage
    intendedAudience
    tileColor
    mediaType {
      name
      icon
    }
  }
  ... on CourseLinkNode {
    id
    mediaType {
      name
      icon
    }
    banner {
      backgroundColor
      imageUrl
    }
    course {
      slug
      title
      subtitle
      thumbnailImageUrl
      duration
      isNew
      progressPercent
      progress {
        completedAt
        startedAt
      }
      hero {
        ... on VideoContentNode {
          uuid
          title
          sourceHorizontal
          sourceVertical
          id
          poster
        }
        ... on ImageNode {
          uuid
          id
          url
        }
        ... on CourseGraphicHeroNode {
          uuid
          id
          graphic {
            uuid
            id
            url
          }
          backgroundColor
        }
      }
    }
  }
  ... on CircleTopicLinkNode {
    id
    circleTopic {
      id
      name
      description
      slug
      duration
      format
      sessions {
        edges {
          node {
            startTime
            facilitators {
              photo
            }
          }
        }
      }
    }
  }
  ... on CircleSeriesLinkNode {
    id
    circleSeries {
      id
      uuid
      url
      description
      shortDescription
      name
      illustration
      slug
      topics {
        edges {
          node {
            id
            duration
          }
        }
      }
    }
  }
  ... on HRResourceLinkNode {
    mediaType {
      name
      icon
    }
    hrResource {
      title
      subtitle
      url
      intendedAudience
      image
    }
  }
  ... on HREventLinkNode {
    hrEvent {
      title
      url
      image
      intendedAudience
      descriptiveDate
    }
  }
}
    ${ProgramPreviewFragmentDoc}`;
export const ScreenSectionFragmentDoc = gql`
    fragment ScreenSection on ScreenSectionNode {
  id
  uuid
  index
  renderComponent
  minimumMobileVersion
  ctaLinkText
  ctaLink {
    ... on Node {
      id
    }
    ...ContentLink
  }
  title
  subtitle
  contentCollectionLinks {
    ... on Node {
      id
    }
    ...ContentLink
  }
}
    ${ContentLinkFragmentDoc}`;
export const ScreenFragmentDoc = gql`
    fragment Screen on HomeScreenNode {
  id
  uuid
  name
  platform
  scheduledContent {
    uuid
    ...ScheduledContent
  }
  bannerContent {
    ...BannerContent
  }
  screenSections {
    id
    ...ScreenSection
  }
  featuredSection {
    id
    ...ScreenSection
  }
}
    ${ScheduledContentFragmentDoc}
${BannerContentFragmentDoc}
${ScreenSectionFragmentDoc}`;
export const GetHomeScreenDocument = gql`
    query getHomeScreen($fetchScheduledContentActivity: Boolean!) {
  homeScreen(platform: WEB) {
    id
    ...Screen
  }
  scheduledContentActivity @include(if: $fetchScheduledContentActivity) {
    dayStreakCount
    weekStreakCount
  }
}
    ${ScreenFragmentDoc}
${ScheduledContentFragmentDoc}
${BannerContentFragmentDoc}
${ScreenSectionFragmentDoc}
${ContentLinkFragmentDoc}
${ProgramPreviewFragmentDoc}`;
export type GetHomeScreenComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetHomeScreenQuery, GetHomeScreenQueryVariables>, 'query'> & ({ variables: GetHomeScreenQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetHomeScreenComponent = (props: GetHomeScreenComponentProps) => (
      <ApolloReactComponents.Query<GetHomeScreenQuery, GetHomeScreenQueryVariables> query={GetHomeScreenDocument} {...props} />
    );
    
export type GetHomeScreenProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetHomeScreenQuery, GetHomeScreenQueryVariables>
    } & TChildProps;
export function withGetHomeScreen<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetHomeScreenQuery,
  GetHomeScreenQueryVariables,
  GetHomeScreenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetHomeScreenQuery, GetHomeScreenQueryVariables, GetHomeScreenProps<TChildProps, TDataName>>(GetHomeScreenDocument, {
      alias: 'getHomeScreen',
      ...operationOptions
    });
};

/**
 * __useGetHomeScreenQuery__
 *
 * To run a query within a React component, call `useGetHomeScreenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHomeScreenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHomeScreenQuery({
 *   variables: {
 *      fetchScheduledContentActivity: // value for 'fetchScheduledContentActivity'
 *   },
 * });
 */
export function useGetHomeScreenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetHomeScreenQuery, GetHomeScreenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetHomeScreenQuery, GetHomeScreenQueryVariables>(GetHomeScreenDocument, options);
      }
export function useGetHomeScreenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetHomeScreenQuery, GetHomeScreenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetHomeScreenQuery, GetHomeScreenQueryVariables>(GetHomeScreenDocument, options);
        }
export type GetHomeScreenQueryHookResult = ReturnType<typeof useGetHomeScreenQuery>;
export type GetHomeScreenLazyQueryHookResult = ReturnType<typeof useGetHomeScreenLazyQuery>;
export type GetHomeScreenQueryResult = ApolloReactCommon.QueryResult<GetHomeScreenQuery, GetHomeScreenQueryVariables>;